export default __webpack_public_path__ + "77e50ab1eee2eea0a44238ef8502950a.ttf";